import React, { useMemo } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';

const getColorByType = (typeText) => {
    const lower = (typeText || '').toLowerCase();
    if (lower.includes('ret') || lower.includes('rej')) return '#D32F2F';
    if (lower.includes('iade') || lower.includes('return')) return '#EF6C00';
    return '#2E7D32';
};

const getIconByType = (typeText) => {
    const lower = (typeText || '').toLowerCase();
    if (lower.includes('ret') || lower.includes('rej')) return 'pi pi-times';
    if (lower.includes('iade') || lower.includes('return')) return 'pi pi-replay';
    return 'pi pi-check';
};

const ApprovalHistoryTimeline = ({ history = [] }) => {
    const { th, getCurrentLocale } = useLanguage();

    const sortedHistory = useMemo(() => {
        return [...history].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    }, [history]);

    if (!sortedHistory.length) {
        return (
            <div className="text-center p-3 text-color-secondary">
                {th('vehicleSalesOrderRequests.detail.noHistory')}
            </div>
        );
    }

    return (
        <div className="flex flex-column gap-3">
            {sortedHistory.map((item, index) => {
                const color = getColorByType(item.typeText);
                const icon = getIconByType(item.typeText);

                return (
                    <div key={index} className="flex gap-3 align-items-start">
                        {/* Marker */}
                        <div className="flex flex-column align-items-center" style={{ minWidth: '2rem' }}>
                            <span
                                className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle shadow-2 flex-shrink-0"
                                style={{ backgroundColor: color }}
                            >
                                <i className={icon} style={{ fontSize: '0.85rem' }}></i>
                            </span>
                            {index < sortedHistory.length - 1 && (
                                <div style={{ width: '2px', backgroundColor: '#dee2e6', flexGrow: 1, minHeight: '1rem' }}></div>
                            )}
                        </div>

                        {/* Content */}
                        <div
                            className="p-3 border-round shadow-1 border-1 border-200 flex-grow-1 mb-1"
                            style={{ backgroundColor: '#fff' }}
                        >
                            <div className="flex align-items-center gap-2 mb-2">
                                {item.typeText && (
                                    <span className="font-bold text-base" style={{ color }}>{item.typeText}</span>
                                )}
                                {item.createdDate && (
                                    <span className="text-color-secondary" style={{ fontSize: '0.9rem' }}>
                                        {new Date(item.createdDate).toLocaleString(getCurrentLocale(), { dateStyle: 'medium', timeStyle: 'short' })}
                                    </span>
                                )}
                            </div>

                            {item.createdName && (
                                <div className="mb-2 text-900" style={{ fontSize: '0.95rem' }}>
                                    <i className="pi pi-user mr-2 text-600"></i>
                                    {item.createdName}
                                </div>
                            )}

                            {item.description && (
                                <div
                                    className="p-2 border-round"
                                    style={{ backgroundColor: '#f8f9fa', fontSize: '0.95rem', lineHeight: '1.5' }}
                                >
                                    <strong className="text-700">{th('vehicleSalesOrderRequests.history.description')}:</strong>{' '}
                                    <span className="text-900">{item.description}</span>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ApprovalHistoryTimeline;
